// Story 061 — rendered when window.location.hostname doesn't match any
// tenant entry. Self-contained: no AuthProvider, no NetworkProvider, no
// Supabase client (which is a dummy in this state). Just a clean message
// so it's obvious to the operator what's wrong.

import { useTranslation } from 'react-i18next';

export function TenantNotFoundPage() {
  const { t } = useTranslation('common');
  const host =
    typeof window !== 'undefined' ? window.location.hostname : 'unknown';
  return (
    <div
      data-testid="tenant-not-found"
      className="flex min-h-screen items-center justify-center bg-background p-6"
    >
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-semibold">{t('tenant_not_found.title')}</h1>
        <p className="text-muted-foreground">
          {t('tenant_not_found.body')}
        </p>
        <p className="rounded border bg-muted/30 px-3 py-2 font-mono text-sm">
          {host}
        </p>
        <p className="text-sm text-muted-foreground">
          {t('tenant_not_found.contact')}
        </p>
      </div>
    </div>
  );
}
